/**
 * Shared styling for the event detail page's new blocks.
 *
 * `labelStyle`'s colour is deliberately 0.55 alpha, not the 0.45 the
 * design draft used: on the dark ground that measured 4.36:1, under the
 * 4.5:1 axe enforces at this size (§ docs/EVENT_DETAIL_REDESIGN.md §7.1).
 * 0.55 lands at 6.05:1.
 */
export const sectionHeadingStyle = {
  fontFamily: "var(--font-serif)",
  fontSize: "28px",
  lineHeight: 1.25,
  color: "var(--color-cream)",
  borderLeft: "2px solid var(--color-gold)",
  paddingLeft: "20px",
  margin: 0,
};

export const labelStyle = {
  // Explicit: this style is also used on an <h3>, and global.css now puts
  // every heading in the serif face. These are small uppercase labels,
  // not display headings — they stay sans.
  fontFamily: "var(--font-sans)",
  fontSize: "10px",
  // Explicit, because this style is also used on an <h3> (the day
  // headings in EventSchedule), and a heading defaults to bold. Only
  // Inter 400 and 500 are self-hosted, so a request for 700 made Chrome
  // fall back per glyph — half the line in Helvetica, half in Inter,
  // which reads as parts of the word being a different colour.
  fontWeight: 500,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "rgba(254,250,239,0.55)",
};

export const valueStyle = { fontSize: "15px", lineHeight: 1.5, color: "var(--color-cream)" };
